module.exports = __webpack_public_path__ + "img/IMG_1297.755a70b9.png";